import { getFormattedDateTime } from '@/core/shared'

export function TableDataPreparer (tableData, itemStructure) {

	var COMPLETED_STATUS_FRAGMENT_CLASS = 'completed-status-frag'
	var UNCOMPLETED_STATUS_FRAGMENT_CLASS = 'uncompleted-status-frag'

	var attributesToPrepare = {
		'status': prepareItemStatus,
		'created': prepareItemDate,
		'updated': prepareItemDate
	}

	var attributeTypesToPrepare = {
		'A': prepareAttributeA
	}

	_.each(tableData, function (key, index) {
		_.each(key, function (attributeValue, attributeKey) {
			var attributeName = attributeKey.split('__0')[0]
			if (itemStructure[attributeName]) {
				if (!_.isUndefined(attributesToPrepare[attributeName])) {
					tableData[index][attributeKey] = attributesToPrepare[attributeName](attributeValue)
				} else {
					var type = itemStructure[attributeName]['type']
					if (!_.isUndefined(attributeTypesToPrepare[type])) {
						tableData[index][attributeKey] = attributeTypesToPrepare[type](attributeValue)
					}
				}
			} else {
				if (!_.isUndefined(attributesToPrepare[attributeName])) {
					tableData[index][attributeKey] = attributesToPrepare[attributeName](attributeValue)
				}
			}
		})
	})

	function prepareItemStatus (value) {
		var valueHtml = ''
		for (var statusFragment in value) {
			//TODO: add NONE status support
			var statusValue = value[statusFragment]
			if (statusValue == 'TRUE' || statusValue == 'FALSE') {
				valueHtml += ('<span data-name="' + statusFragment + '" class="'
					+ (statusValue == 'TRUE' ? COMPLETED_STATUS_FRAGMENT_CLASS : UNCOMPLETED_STATUS_FRAGMENT_CLASS)
					+ '">' + statusFragment + '</span>')
			}
		}
		return valueHtml
	}

	function prepareItemDate (value) {
		var date = new Date(value)
		return getFormattedDateTime(date)
	}

	function prepareAttributeA (value) {
		return !_.isEmpty(value) ? "<span class='fa fa-picture-o'></span>" : value;
	}
}
